import { StrictMode, type ReactNode } from 'react';
import { Theme } from '@mds/web-ui-theme';
import '@mds/web-ui-theme/cmb';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

interface AppProvidersProps {
  children: ReactNode;
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <Theme brand="cmb">{children}</Theme>
      </QueryClientProvider>
    </StrictMode>
  );
}

export default AppProviders;
